import { render, staticRenderFns } from "./AutomaticPartialResult.vue?vue&type=template&id=0bce0651&lang=html&"
import script from "./AutomaticPartialResult.vue?vue&type=script&lang=js&"
export * from "./AutomaticPartialResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports